<template>
  <div v-click-outside-textInput="closePopup" class="relative w-full">
    <!-- Label and character count -->
    <p class="flex justify-between mb-1">
      <span>{{ lableText }}</span>
      <span v-if="showcharLimit" class="text-xs text-gray-500">{{ inputValue.length }}/{{ textMaxlength }}</span>
    </p>

    <!-- Input wrapper -->
    <div class="relative w-full">
      <input
        :maxlength="textMaxlength"
        v-model="inputValue"
        :type="inputTypeText"
        :disabled="disabled"
        :readonly="setReadOnly"
        :pattern="pattern"
        autocomplete="off"
        :id="inputId"
        :placeholder="placeholderType !== 'floating' ? placholderText : ''"
        :class="['floating-input', borderClass, { 'border-error': showError }]"
        @focus="focusInput"
        @blur="blurInput"
        @input="inputChangeAction(inputValue)"
      />

      <!-- Floating label (only for floating border type) -->
      <label
        v-if="placeholderType === 'floating'"
        :for="inputId"
        class="floating-label"
        :class="{ 'floating-label-active': inputValue || isFocused }"
      >
        {{ placholderText }}
      </label>

      <!-- Password toggle -->
      <span
        v-if="inputType === 'password'"
        @click.stop.prevent="hidePassword = !hidePassword"
        class="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
      >
        <i v-if="hidePassword" class="fa-solid fa-eye text-gray-400"></i>
        <i v-else class="fa-solid fa-eye-slash text-gray-400"></i>
      </span>

      <!-- Date picker icon -->
      <span
        v-if="showDate"
        @click="onClickInputAction"
        class="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
      >
        <i class="fa-solid fa-calendar-days text-gray-400"></i>
      </span>

      <!-- Time picker icon -->
      <span
        v-if="showTime"
        @click="onClickInputAction"
        class="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
      >
        <i class="fa-regular fa-clock text-primary"></i>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

Vue.directive("click-outside-textInput", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

export default {
  props: [
    "maxNumberLimit",
    "pattern",
    "isOtp",
    "isPointer",
    "showcharLimit",
    "textRight",
    "inputext",
    "textMaxlength",
    "lableText",
    "inputId",
    "autoFocus",
    "fieldError",
    "setReadOnly",
    "placholderText",
    "inputType",
    "showDate",
    "disabled",
    "showTime",
    "placeholderType"
  ],
  data() {
    return {
      inputTypeText: "text",
      hidePassword: true,
      showError: false,
      setAutoFocust: false,
      inputValue: "",
      isFocused: false
    };
  },
  computed: {
    borderClass() {
      if (this.placeholderType === "floating") {
        return "border border-gray-300 focus:border-primary focus:ring-0";
      }
      return "border border-gray-300 rounded focus:border-primary focus:ring-1 focus:ring-primary";
    }
  },
  watch: {
    fieldError(val) {
      this.showError = val;
    },
    hidePassword(val) {
      this.inputTypeText = val ? "password" : "text";
      this.$nextTick(() => {
        document.getElementById(this.inputId)?.focus();
      });
    },
    inputext(val) {
      this.inputValue = val || "";
    }
  },
  mounted() {
    this.showError = this.fieldError;
    this.inputTypeText = this.inputType;
    if (this.autoFocus) {
      this.$nextTick(() => {
        document.getElementById(this.inputId)?.focus();
      });
    }
    if (this.inputext) this.inputValue = this.inputext;
  },
  methods: {
    focusInput() {
      this.isFocused = true;
    },
    blurInput() {
      this.isFocused = false;
    },
    inputChangeAction(val) {
      if (this.inputType === "number" && this.maxNumberLimit) {
        if (parseInt(val) > parseInt(this.maxNumberLimit)) {
          this.inputValue = this.maxNumberLimit;
          this.$emit("inputChangeAction", this.maxNumberLimit);
          return;
        }
      }
      this.$emit("inputChangeAction", val);
    },
    onClickInputAction() {
      document.getElementById(this.inputId)?.focus();
      this.$emit("onClickInputAction");
    },
    closePopup() {
      this.$emit("closePopup");
    }
  }
};
</script>

<style>
.floating-input {
  width: 100%;
  padding: 12px 12px;
  font-size: 16px;
  outline: none;
  background: white;
  transition: border-color 0.2s;
}

.floating-input:focus {
  border-color: #1295BA;
}

.floating-label {
  position: absolute;
  left: 12px;
  top: 15px;
  color: #9ca3af;
  font-size: 16px;
  pointer-events: none;
  transition: all 0.2s ease;
  background: white;
}

.floating-label-active {
  top: -6px;
  left: 8px;
  font-size: 12px;
  color: #1295BA;
  padding: 0 4px;
}

.border-error {
  border-color: #ef4444 !important;
}
</style>
